import React, { useState, useEffect } from "react";
import axios from "axios";
import Apiurl from "../Apiurl";

export default function Branchoptions() {
  const apiurl = Apiurl();
  const [data, setdata] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(`${apiurl}branch/`);

      const convertedarray = response.data.map((item, index) => ({
        value: item.branch_name,
        label: item.branch_name,
      }));
      setdata(convertedarray);
      console.log(convertedarray);
    } catch (error) {
      console.warn("Error fetching data:", error);
      alert(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return data;
}
